var path = '/modules/media/views/download.tpl.html';
var html = "<section ng-if=\"vm.loading\">\n    <div class=\"dashboard-empty\">\n        <div class=\"pacman\">\n            <i class=\"fal fa-sync fa-spin\"></i>\n            <h2>{{'media.preparing' | translate}}</h2>\n        </div>\n    </div>\n</section>\n\n<section ng-if=\"!vm.loading\">\n    <h3>{{'media.started' | translate}}</h3>\n</section>\n<section ng-if=\"vm.error.active\">\n    <h3>{{'media.error' | translate}}</h3>\n</section>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/media/views/download.tpl.html
// module id = 2135
// module chunks = 1